import React, {Component} from "react";

class StickyRight extends Component {
  constructor(props) {
    super(props)
    this.updateFix = this.updateFix.bind(this)
    this.els = {}
    this.currentScroll = 0;
  }

  componentDidMount() {
    this.els.element = this.props.proxy;
    this.els.parent = this.els.element.parentNode;
    this.els.big = this.els.parent.parentNode.parentNode;

    this.els.element.classList.add('sticky');

    window.els = this.els;

    window.addEventListener('scroll', this.updateFix);
    window.addEventListener('resize', this.updateFix);
    this.updateFix();
  }

  get elementHeight() {
    return this.els.element.offsetHeight
  }

  updateFix() {
    let bigRect = this.els.big.getBoundingClientRect()
    let rect = this.els.parent.getBoundingClientRect()
    let prevScroll = this.currentScroll;
    let currentScroll = this.currentScroll = window.scrollY || window.pageYOffset;
    let maxScroll = currentScroll + bigRect.bottom - this.elementHeight - 8
    let windowWidth = window.innerWidth;
    let windowHeight = window.innerHeight;
    let windowBottom = currentScroll + windowHeight;
    let goingDown = prevScroll < currentScroll;

    if (windowWidth >= 1024) {
      if (rect.bottom >= bigRect.bottom) return

      if ((this.elementHeight + 80) < windowHeight && rect.top <= 80 && currentScroll < maxScroll - 80) {
        this.els.element.style.position = 'fixed'
        this.els.element.style.bottom = 'initial'
        this.els.element.style.top = (80) + 'px'
        this.els.element.style.left = rect.left + 'px'
        this.els.element.style.width = rect.width + 'px'
      }
      else if ((this.elementHeight + 80) >= windowHeight && rect.top <= 80 && windowBottom < currentScroll + bigRect.bottom) {
        //console.log('down', goingDown);
        let elRect = this.els.element.getBoundingClientRect();
        if (goingDown && windowBottom >= elRect.bottom + currentScroll) {
          this.els.element.style.position = 'fixed'
          this.els.element.style.left = rect.left + 'px'
          this.els.element.style.width = rect.width + 'px'
          this.els.element.style.top = 'initial'
          this.els.element.style.bottom = 0 + 'px'
        } else if (!goingDown && currentScroll <= elRect.top + currentScroll - 80) {
          this.els.element.style.position = 'fixed'
          this.els.element.style.left = rect.left + 'px'
          this.els.element.style.width = rect.width + 'px'
          this.els.element.style.bottom = 'initial'
          this.els.element.style.top = 80 + 'px'
        } else if (this.els.element.style.position === 'fixed') {
          this.els.element.style.position = 'absolute'
          this.els.element.style.top = (elRect.top - rect.top + this.els.parent.offsetTop) + 'px';
          this.els.element.style.left = 'initial'
          this.els.element.style.bottom = 'initial'
          this.els.element.style.width = rect.width + 'px'
        }
      }
      else if (currentScroll >= maxScroll - 80) {
        this.els.element.style.position = 'absolute'
        this.els.element.style.top = 'initial'
        this.els.element.style.left = 'initial'
        this.els.element.style.bottom = 0
        this.els.element.style.width = rect.width + 'px'
      }
      else {
        this.els.element.style.position = 'initial'
        this.els.element.style.width = rect.width + 'px'
      }
    }
  }

  render() {
    return <div></div>
  }
}

export default (StickyRight)


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/StickyRight.js